import { Button, useMediaQuery } from "@amphore-dev/amphore-lib";
import { useTranslation } from "react-i18next";

import { useNewTask } from "@/hooks/useNewTask";

import { MOBILE_MEDIA_QUERY } from "@/constants";
import { cn } from "@/utils";

export const NewTaskButton: React.FC = () => {
	const { t } = useTranslation();
	const { canCreate, create } = useNewTask();
	const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
	if (!canCreate) return null;

	return (
		<Button
			size="sm"
			className={cn(["min-w-fit py-2!", isMobile && "rounded-lg! px-2!"])}
			onClick={create}
			picto={"add"}
			data-tour="new-task"
		>
			{!isMobile && t("tasks.newTask")}
		</Button>
	);
};
